module.exports = __webpack_public_path__ + "3778c9d82e6b5db71909ea2afb35274a.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/dances/swing.mp3
// module id = 3266
// module chunks = 0